module.exports = __webpack_public_path__ + "static/media/guide_1.990710ef.gif";